import { IconButton, Stack, TextField } from "@mui/material";
import React from "react";
import CompteSearch from "./autocomplet-search";
import { Delete } from "@mui/icons-material";

export default function DCLine(props) {
    
    return(
        <Stack direction='row' spacing={2}>
            <CompteSearch comptes={props.comptes} setCompte={(cpt)=>props.setCompte(cpt)} default={props.default} style={{width:'20%', minWidth:'300px'}} />
            <TextField variant="standard" fullWidth label="Libellé" value={props.line.label} onChange={(e)=>props.setLabel(e.target.value)} type="text" sx={{minWidth:'250px'}}/>
            <TextField label="Montant" type="text" inputMode="decimal" value={props.line.amount} onChange={(e)=>{const newValue = e.target.value; const regex = /^-?\d*\.?\d{0,2}$/;
            if (regex.test(newValue) || newValue === '') {props.setMontant(parseFloat(newValue))}}} sx={{minWidth:'120px'}}/>
            {props.can_del&&<IconButton onClick={props.del}><Delete/></IconButton>}
        </Stack>
    )
}